import { webApi } from '@mi-front/api-clients';
import { AppCardRouterTo } from '@app/components/base/app-card';

/**
 * Builds the logger stream route for a YouTube broadcast interval.
 * Same destination as {@link YoutubeBroadcastItem} click navigation.
 */
export function buildYoutubeBroadcastNavigation(
  broadcast: webApi.BroadcastDto,
  stationSlug: string,
): AppCardRouterTo {
  const streamStartedAtMs = Date.parse(broadcast.streamStartedAt);
  const streamEndedAtMs = Date.parse(broadcast.streamEndedAt);

  return `/logger/s/${stationSlug}?from=${streamStartedAtMs}&to=${streamEndedAtMs}`;
}
